import IosWifiResolveModal from '@/components/MedicalDepartureWifi/IosWifiResolveModal';
import React, { useState } from 'react';

type Props = {
  place?: 'airport' | 'port';
};

function useWifiResolveModal({ place }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const onOpenModal = () => {
    setIsOpen(true);
  };

  const Modal = isOpen ? (
    <IosWifiResolveModal onClose={() => setIsOpen(false)} place={place} />
  ) : null;

  return {
    onOpenModal,
    Modal,
  };
}

export default useWifiResolveModal;
